import { http } from '@/core/api/';

const baseUrl = 'api/pei/saee10';

export const getInformationHeader = async (requestId) => {
  return await http.get(`${baseUrl}/informationheader/${requestId}`);
};

export const getSAEE10Data = async (saee10Id) => {
  return await http.get(`${baseUrl}/${saee10Id}`);
};

export const initFilters = () => http.get(`${baseUrl}/initfilters`);

export const GetNecesitiesByYear = (academicYearId) =>
  http.get(`${baseUrl}/necesities/${academicYearId}`);

export const GetVacantPositions = (schoolId, academicYearId) =>
  http.get(
    `${baseUrl}/vacantPositions?schoolId=${schoolId}&academicYearId=${academicYearId}`
  );

export const SetAsVacantPosition = (saee10Id) =>
  http.put(`${baseUrl}/vacantPosition/${saee10Id}`);

export const SetAsPendingAmendment = (saee10Id) =>
  http.put(`${baseUrl}/pendingAmendment/${saee10Id}`);

export const AssignAssistant = (
  saee10Id,
  assistantIds,
  alternativeLocationTeacherId
) =>
  http.put(`${baseUrl}/assign/${saee10Id}`, {
    assistantIds: Array.isArray(assistantIds) ? assistantIds : [assistantIds],
    alternativeLocationTeacherId:
      alternativeLocationTeacherId > 0 ? alternativeLocationTeacherId : null,
  });

export const ValidateAssistantCertification = (academicYearId, schoolId) =>
  http.get(`${baseUrl}/validatecertification/${academicYearId}/${schoolId}`);

export const GetRequest = async (filters) =>
  http.get(`${baseUrl}/search`, {
    params: { ...filters },
  });

export const CancelRequest = async (saee10Id, reason) =>
  http.put(`${baseUrl}/cancel/${saee10Id}`, {
    reason,
  });

export const GetValidations = async (filters, schoolId) =>
  http.get(`${baseUrl}/validaterequestassistanse`, {
    params: { ...filters, schoolId },
  });
export const GetStatusList = () => http.get(`${baseUrl}/list/status`);

export const GetAssistantList = (academicYearId, schoolId) =>
  http.get(`${baseUrl}/list/assistant/${academicYearId}/${schoolId}`);

export const GetApproachTypeList = () =>
  http.get(`${baseUrl}/list/approachtype`);

export const GetCustodians = (schoolId = 0) =>
  http.get(`${baseUrl}/custodians?schoolId=${schoolId}`);

export const CreateNewRequest = (request) =>
  http.post(`${baseUrl}/request`, request);

export const CreateRequestDocuments = (request) =>
  http.post(`${baseUrl}/request/documents`, request);

export const SubmitRequest = (requestId, request) =>
  http.put(`${baseUrl}/submitrequest/${requestId}`, request);

export const SubmitNewRequest = (request) =>
  http.post(`${baseUrl}/submitrequest`, request);

export const getProvRemRequestData = (params) =>
  http.get(`${baseUrl}/rp/provremrequestdata`, { params });

export const submitProvRemRequest = (requestId, provRemRequest) =>
  http.post(`${baseUrl}/rp/submitprovremrequest/${requestId}`, provRemRequest);

export const GetRequestData = (requestId) =>
  http.get(`${baseUrl}/request/${requestId}`);

export const UpdateRequest = (requestId, payload) =>
  http.put(`${baseUrl}/request/${requestId}`, payload);

export const getHistory = (saee10Id) =>
  http.get(`${baseUrl}/history/${saee10Id}`);

export const getIfHasSubmittedInfo = (peiId) =>
  http.get(`${baseUrl}/has-submitted-info/${peiId}`);

export const ChangeToPendingAssign = (saee10Id) =>
  http.put(`${baseUrl}/change-to-pending-assign/${saee10Id}`);
